/* istanbul ignore file */
export { default } from './MaintenanceMessage';
export { MaintenanceMessage } from './MaintenanceMessage';
